export const GetTokenForQueryBuilder = (dbType: string) => `React${dbType}`;